import { Events } from '@platform/client';
import { EventCard } from '../events/EventCard';
import { ViewAllCard } from './ViewAllCard';

export const EventsSegment = () => {
  const previewEvents = Events.useGetUpcomingEvents({ page: 0, limit: 3, sort: 'start_time:ASC' });
  return (
    <div className='w-full' data-testid='eventsSegment'>
      <h1 className='text-display-sm font-gray-700 pt-5'>Events</h1>
      <div className='w-full mt-4 mb-4 bg-white rounded-xl p-4 border border-gray-100 '>
        {previewEvents.data?.map((event) => {
          return <EventCard event={event} key={event.id} />;
        })}
        <ViewAllCard link='/events' />
      </div>
    </div>
  );
};
